import React, { useState } from "react";
import { motion } from "framer-motion";
import ProjectCard from "./ProjectCard";
import { useProjects } from "../dashboard/useProjects";
import SubPageLoader from "../../ui/SubPageLoader";

const Projects = () => {
  const { projects, isLoading, error } = useProjects();
  const [activeTab, setActiveTab] = useState("All");

  if (isLoading) {
    return <SubPageLoader />;
  }

  if (error) return <div className="text-center text-red-500">Error loading projects</div>;

  // Extract unique categories
  const categories = ["All", ...new Set(projects?.map((item) => item.category).filter(Boolean))];

  const filteredProjects =
    activeTab === "All"
      ? projects
      : projects?.filter((item) => item.category === activeTab);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20 pb-20"
    >
      <div className="w-full">
        {/* Header */}
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2023 - 2025</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-700 dark:text-gray-300">Projects</h2>
        </div>

        {/* Tab Buttons */}
        <div className="flex flex-wrap gap-4 mb-10">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveTab(category)}
              className={`px-6 py-2 rounded-lg text-sm font-medium transition-all duration-300 
                ${activeTab === category 
                  ? "bg-designColor text-white shadow-lg" 
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-black dark:bg-opacity-40 dark:text-gray-400 dark:hover:bg-opacity-60"}`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="mt-5 w-full h-auto border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-4">
            {filteredProjects?.map((project) => (
                <ProjectCard
                key={project.id}
                title={project.title}
                description={project.description}
                image={project.image}
                link={project.link}
                github_link={project.github_link}
                category={project.category}
                />
            ))}
            </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Projects;
